import {texts} from './texts';
import {AnnouncementItems} from '../consts/types';
import welcome from '../../../images/Announcements251Welcome.png';
import {isRTL} from '../../../Localization';
import chartEng from '../../../images/AIAnalyticsCharts_eng.png';
import chartHeb from '../../../images/AIAnalyticsCharts_heb.png';
import optimizationEng from '../../../images/Optimization_eng.png';
import optimizationHeb from '../../../images/Optimization_heb.png';
import newEmailEng from '../../../images/NewEmailExperience_eng.png';
import newEmailHeb from '../../../images/NewEmailExperience_heb.png';
import serviceFieldAppEng from '../../../images/ServiceFieldsApp_eng.png';
import serviceFieldAppHeb from '../../../images/ServiceFieldsApp_heb.png';

const isRtl = isRTL();

export const ver2501: () => AnnouncementItems[] = () => {
    return [
        {
            type: 'Welcome',
            title: texts.welcomePageTitle,
            content: texts.welcomePageText,
            additionalContent: welcome,
            linkText: texts.showMe
        },
        {
            type: 'Content',
            title: texts.AIinChartsTitle,
            content: texts.AIinChartsText,
            additionalContent: isRtl ? chartHeb : chartEng,
            linkText: texts.showMe
        },
        {
            type: 'Content',
            title: texts.optimizationTitle,
            content: texts.optimizationText,
            additionalContent: isRtl ? optimizationHeb : optimizationEng,
            linkText: texts.showMe
        },
        {
            type: 'Content',
            title: texts.newEmailTitle,
            content: texts.newEmailText,
            additionalContent: isRtl ? newEmailHeb : newEmailEng,
            linkText: texts.showMe
        },
        {
            type: 'Content',
            title: texts.serviceFieldAppTitle,
            content: texts.serviceFieldAppText,
            additionalContent: isRtl ? serviceFieldAppHeb : serviceFieldAppEng,
            linkText: texts.showMe
        }
    ];
};
